

export default function SchoolHeroSection() {
  const handleConsultationClick = () => {
    const ctaSection = document.querySelector('[data-cta-section]');
    if (ctaSection) {
      ctaSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative h-[70vh] md:h-[70vh] sm:h-[60vh] flex items-center justify-center overflow-hidden">
      {/* 背景画像 */}
      <div 
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: 'url(https://static.readdy.ai/image/b1b0be4a533f8dd52f529875d332f87d/c9ffccdb8adf90b85e9a6fd3ef85d8c1.webp)'
        }}
      ></div>

      {/* オーバーレイ */}
      <div className="absolute inset-0 bg-black/40"></div>

      {/* コンテンツ */}
      <div className="relative z-10 w-full max-w-6xl mx-auto px-6 sm:px-4">
        <div className="flex items-center justify-start">
          <div className="text-white max-w-2xl ml-2 sm:ml-0">
            <h1 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold mb-4 sm:mb-3 leading-tight sm:leading-snug">
              <span className="text-[#76B947]">プロの操縦技術</span>を<br />
              確実に習得
            </h1>
            
            <p className="text-sm sm:text-base md:text-lg lg:text-xl mb-8 sm:mb-6 leading-relaxed sm:leading-relaxed">
              IDS教習所グループは農業ドローン協議会認定の教習施設。<br className="hidden sm:block" />
              DJI農業ドローン運用に必要な民間資格「オペレーター技能認定」を、<br className="hidden sm:block" />
              経験豊富な認定インストラクターが対面で丁寧に指導します。
            </p>

            <div className="flex justify-start items-start">
              <button 
                onClick={handleConsultationClick}
                className="px-6 sm:px-4 md:px-8 py-3 sm:py-2 bg-[#FFC107] text-black rounded-lg hover:bg-yellow-500 transition-colors text-sm sm:text-base md:text-lg font-bold whitespace-nowrap cursor-pointer"
              >
                無料で受講相談
              </button>
            </div>

            {/* 認定情報 */}
            <div className="opacity-90 mt-8">
              <span className="text-xs sm:text-sm text-gray-300 mb-2 sm:mb-1 block">認定・対応機種</span>
              <div className="flex flex-wrap justify-start items-center gap-2 sm:gap-1">
                <div className="bg-white/20 backdrop-blur-sm px-2 sm:px-2 py-1 sm:py-1 rounded-lg">
                  <span className="text-white font-semibold text-xs sm:text-sm">DJI AGRAS T70P</span>
                </div>
                <div className="bg-white/20 backdrop-blur-sm px-2 sm:px-2 py-1 sm:py-1 rounded-lg">
                  <span className="text-white font-semibold text-xs sm:text-sm">DJI AGRAS T50</span>
                </div>
                <div className="bg-white/20 backdrop-blur-sm px-2 sm:px-2 py-1 sm:py-1 rounded-lg">
                  <span className="text-white font-semibold text-xs sm:text-sm">DJI AGRAS T25P</span>
                </div>
                <div className="bg-white/20 backdrop-blur-sm px-2 sm:px-2 py-1 sm:py-1 rounded-lg">
                  <span className="text-white font-semibold text-xs sm:text-sm">DJI AGRAS T25</span>
                </div>
                <div className="bg-white/20 backdrop-blur-sm px-2 sm:px-2 py-1 sm:py-1 rounded-lg">
                  <span className="text-white font-semibold text-xs sm:text-sm">DJI AGRAS T10</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

